import { render } from "./NavbarLogo.vue?vue&type=template&id=5189f986&scoped=true"
import script from "./NavbarLogo.vue?vue&type=script&lang=js"
export * from "./NavbarLogo.vue?vue&type=script&lang=js"

import "./NavbarLogo.vue?vue&type=style&index=0&id=5189f986&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5189f986"]])

export default __exports__